import { ProductType } from '@pages/product-analyzer/Product';
import { Action, SubscribedProductTypesType } from '@state/actions/Type';

export interface SubscribedProductTypesState {
  subscribedProductTypes: ProductType[];
}

const initialState: SubscribedProductTypesState = {
  subscribedProductTypes: [],
};

const SubscribedProductTypesReducer = (
  state: SubscribedProductTypesState = initialState,
  action: Action,
): SubscribedProductTypesState => {
  switch (action.type) {
    case SubscribedProductTypesType.SubscribedProductTypeAdded:
      return {
        subscribedProductTypes: [...state.subscribedProductTypes, action.payload],
      };
    case SubscribedProductTypesType.SubscribedProductTypesCleared:
      return initialState;
    default: {
      return state;
    }
  }
};

export default SubscribedProductTypesReducer;
